import React from 'react';

function LoadingOverlay({ isLoading, message = 'Carregando...' }) {
    if (!isLoading) return null;

    return (
        <div 
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 99999,
                    cursor: 'default',
                    userSelect: 'none'
                }}
            >
                <div 
                    style={{
                        width: '80px',
                        height: '80px',
                        border: '8px solid transparent',
                        borderTop: '8px solid rgb(235, 133, 0)',
                        borderRight: '8px solid rgb(235, 133, 0)',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        marginBottom: '20px',
                        pointerEvents: 'none'
                    }}
                />
                <p style={{
                    color: 'rgb(235, 133, 0)',
                    fontSize: '18px',
                    fontWeight: '600',
                    margin: 0,
                    textAlign: 'center',
                    userSelect: 'none'
                }}>
                    {message}
                </p>
            
            <style>
                {`
                    @keyframes spin {
                        from {
                            transform: rotate(0deg);
                        }
                        to {
                            transform: rotate(360deg);
                        }
                    }
                `}
            </style>
        </div>
    );
}

export default LoadingOverlay;
